import React, { useContext, useEffect, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { isEmpty } from "lodash";
import { SignIn } from 'components/Authentication/SignIn';
import { SignUp } from 'components/Authentication/SignUp';
import { ForgotPassword } from 'components/Authentication/ForgotPassword';
import { protectedAdminRoutes, protectedUserRoutes } from './protectedRoutes';
import { Layout } from 'components/Layout';
import { AdminSignIn } from 'components/Admin/Authentication/SignIn';
import { InviteExpired } from 'components/Authentication/InviteExpired';
import { ResetPassword } from 'components/Authentication/ResetPassword';
import { AuthContext } from "contexts/AuthContext";
import { ConfirmRegistration } from "components/Authentication/ConfirmRegistration";

const AdminRoutes = ({ children }) => {
    const [isAdmin, setIsAdmin] = useState(null);
    const { pathname } = useLocation();
    const { state, logout } = useContext(AuthContext);

    useEffect(() => {
        if (!state.isAuthenticated) {
            setIsAdmin(false);
            logout();

        } else if (!isEmpty(state.profile)) {
            if (!state.profile?.roles.includes('ROLE_SUPER_ADMIN')) {
                logout();
            }
            setIsAdmin(state.profile?.roles.includes('ROLE_SUPER_ADMIN'));
        }
    }, [state]);

    if (isAdmin === null) return null;

    if (!isAdmin && pathname !== "/admin/signin") {
        return <Navigate to="/admin/signin" replace/>;
    }

    if (isAdmin && pathname === '/admin') {
        return <Navigate to="/admin/domains" replace/>;
    }

    return <Layout>{children}</Layout>;
};

const UserRoutes = ({ children }) => {
    const [isUser, setIsUser] = useState(null);
    const { pathname } = useLocation();
    const { state, logout } = useContext(AuthContext);

    useEffect(() => {
        if (!state.isAuthenticated) {
            setIsUser(false);
            logout();
        } else if (!isEmpty(state.profile)) {
            if (!state.profile?.roles.includes('ROLE_USER')) {
                logout();
            }
            setIsUser(state.profile?.roles.includes('ROLE_USER'));
        }
    }, [state]);

    if (isUser === null) return null;

    if (!isUser && pathname !== "/signin") {
        return <Navigate to="/signin" replace/>;
    }

    return <>{children}</>;
};

export const AppRoutes = () => {
    const { state } = useContext(AuthContext);

    if (!state.authChecked) return null;

    return (
        <Routes>
            {/*User Area*/}
            <Route path="/signin" element={<SignIn/>}/>
            <Route path="/signup" element={<SignUp/>}/>
            <Route exact path="/forgot-password" element={<ForgotPassword/>}/>
            <Route path="/invite-expired" element={<InviteExpired/>}/>
            <Route exact path="/reset-password" element={<ResetPassword/>}/>
            <Route path="/registration/confirm" element={<ConfirmRegistration/>}/>
            {protectedUserRoutes.map(({ path, element }) => (
                <Route key={path} path={path} element={<UserRoutes>{element}</UserRoutes>}/>
            ))}

            {/*Admin panel*/}
            <Route path="/admin/signin" element={<AdminSignIn/>}/>
            {protectedAdminRoutes.map(({ path, element }) => (
                <Route key={path} path={path} element={<AdminRoutes>{element}</AdminRoutes>}/>
            ))}

            <Route path="/admin/*" element={<AdminSignIn/>}/>
            <Route path="*" element={<SignIn/>}/>
        </Routes>
    );
};
